import Vue from "vue";
import Vuex from "vuex";
import app from "./modules/app";
import tagsView from "./modules/tagsView";
import getters from "./getters";
import user from "./modules/user";
import product from "./modules/product";
import merchant from "./modules/merchant";
import stock from "./modules/stock";
import order from "./modules/order";
import port from "./modules/port";
import declare from "./modules/declare";
import omsUserStore from "./modules/omsUserStore";
import goodsForRecordStore from "./modules/goodsForRecordStore";
import exceptionTaskStore from "./modules/exceptionTaskStore";
import tro from "./modules/taxRechargeOrderStore";
import tass from "./modules/taxAccountStatementStore";
import ta from "./modules/taxAccountStore";
import cs from "./modules/carrierStore";
import fss from "@/store/modules/FluxWmsStockStore";
import roleStore from "@/store/modules/RoleStore";
import permissionStore from "@/store/modules/PermissionStore";
import rolePermissionStore from "@/store/modules/RolePermissionStore";
import userRoleStore from "@/store/modules/UserRoleStore";
import channelStore from "@/store/modules/ChannelStore";
import merchantStore from "@/store/modules/MerchantStore";
import declareEnterpriseStore from "@/store/modules/DeclareEnterpriseStore";
import customsAccountBookStore from "@/store/modules/CustomsAccountBookStore";
import danding from "@/store/modules/danding";
import platformStore from "@/store/modules/platformStore";
import record from "@/store/modules/record";
import shopAuthStore from "@/store/modules/shopAuthStore";
import customerStore from "./modules/customerStore";

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    app,
    tagsView,
    user,
    product,
    merchant,
    stock,
    order,
    port,
    declare,
    omsUserStore,
    goodsForRecordStore,
    exceptionTaskStore,
    tro,
    tass,
    ta,
    cs,
    fss,
    roleStore,
    permissionStore,
    rolePermissionStore,
    userRoleStore,
    channelStore,
    merchantStore,
    declareEnterpriseStore,
    customsAccountBookStore,
    danding,
    platformStore,
    record,
    shopAuthStore,
    customerStore,
  },
  getters,
  actions: {
    initData(ctx, data) {
      return Promise.all([
        ctx.dispatch("channelStore/listAllChannel", null, { root: true }),
        ctx.dispatch("declareEnterpriseStore/listAllDeclareEnterprise", null, {
          root: true,
        }),
        ctx.dispatch("merchantStore/listAllMerchant", null, { root: true }),
        ctx.dispatch("portList", null, { root: true }),
        ctx.dispatch("customerStore/listAll", null, { root: true }),
        ctx.dispatch("customsAccountBookStore/listAll", null, { root: true }),
      ]).then((res) => {
        return res;
      });
    },
  },
});
export default store;
